import Swiper from "swiper";
import { Navigation, Pagination, Autoplay } from "swiper/modules";


class Slider {
  constructor() {
    this.slider();
  }

  slider() {
    new Swiper(".hero__swiper", {
      modules: [Navigation, Pagination, Autoplay],
      loop: true,
      autoplay: {
        delay: 5000,
        disableOnInteraction: false,
      },
      pagination: {
        el: ".hero__pagination",
        clickable: true,
      },
      navigation: {
        nextEl: ".hero__nav--next",
        prevEl: ".hero__nav--prev",
      },
      speed: 800,
      effect: 'slide',
    });
  }
}

export default Slider;
